import React from "react"
import {House} from "react-bootstrap-icons";

const horizontalMenuConfig = [
  {
    id: "index",
    title: "Strona główna",
    type: "item",
    icon: <House size={20} />,
    navLink: "/",
  },
]

export default horizontalMenuConfig
